import { connectedStore } from '../../store';
import selectors from '../selectors';

const getPages = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getPages(state);
};

export default getPages;
